import { motion } from "framer-motion";

/**
 * Animated, theme-aware library-cleanup mockup: a scan result with a dead link
 * (+ Wayback), a duplicate, and a healthy link. Replaces screenshots.
 */

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.14, delayChildren: 0.2 } },
};
const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

const softBadge = {
  background: "var(--mock-surface)",
  color: "var(--bs-secondary-color, var(--bs-secondary))",
  border: "1px solid var(--mock-border)",
};

export const CleanupMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--cleanup ${className}`}
      variants={container}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">
          <i className="bi bi-magic me-1" />
          Library cleanup
        </div>
      </div>

      <div className="obm-mock__body">
        <div className="obm-mock__list">
          <motion.div className="obm-mock__item" variants={item}>
            <span className="obm-mock__fav" style={{ background: "#9ca3af" }}>
              <i className="bi bi-link-45deg" />
            </span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div
                className="text-truncate"
                style={{ textDecoration: "line-through", opacity: 0.7 }}
              >
                Old resource
              </div>
              <div className="small text-secondary text-truncate">
                deadsite.com/gone
              </div>
            </div>
            <span className="badge bg-danger">Dead</span>
            <span className="badge" style={softBadge}>
              <i className="bi bi-clock-history me-1" />
              Wayback
            </span>
          </motion.div>

          <motion.div className="obm-mock__item" variants={item}>
            <span className="obm-mock__fav" style={{ background: "#047857" }}>
              R
            </span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div className="text-truncate">React docs</div>
              <div className="small text-secondary text-truncate">
                react.dev/learn
              </div>
            </div>
            <span className="badge bg-warning text-dark">Duplicate</span>
          </motion.div>

          <motion.div className="obm-mock__item" variants={item}>
            <span className="obm-mock__fav" style={{ background: "#2563eb" }}>
              D
            </span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div className="text-truncate">Design system</div>
              <div className="small text-secondary text-truncate">
                design.example.com
              </div>
            </div>
            <i className="bi bi-check-circle-fill text-success fs-5" />
          </motion.div>
        </div>

        <motion.div
          variants={item}
          className="small text-secondary mt-3 d-flex align-items-center"
        >
          <i className="bi bi-shield-lock me-2 text-purple" />
          Encrypted bookmarks are never scanned
        </motion.div>
      </div>
    </motion.div>
  );
};

export default CleanupMock;
